import { Button, Col, Form, Input, Radio, Row, Tooltip } from "antd";
import { useEffect, useState } from "react";
import { FormattedMessage } from "react-intl";
import {
  checkIfIdExists,
  dataSuperior,
  dataSuperior0,
  getTranslatedValue,
} from "../utils/Utils";

export const ShowHide = ({
  radio,
  id,
  disabled,
  checked,
  parent,
  value,
  suffix,
  prefix,
  visible,
  toUpdateForm,
  changedValue,
  all,
  activeElement,
  separateTeensAdults,
  separateRole,
  showHourly,

  idOfTooltip,
  showInput,
  toHideUnhide,
  toUpdateRadio,
  staffTime,
}) => {
  const [active, setActive] = useState(
    activeElement != -1 ? activeElement : false
  );
  const [suffixValue, setSuffixValue] = useState(suffix);
  const [prefixValue, setPrefixValue] = useState(prefix);
  const [selected, setSelected] = useState(checked == true ? 1 : 2);
  const [defaultValue, setDefaultValue] = useState(null);
  const [changed, setChanged] = useState({});
  const [form] = Form.useForm();
  const dataToCheckSup1 = [
    "newPatientOneYear",
    "avgTreatment",
    "averagePrice",
    "addFeeAligners",
    "averagePriceBrace",
    "addFeeBraces",
    "doctorCostHour",
    "leadToFirstConsult",
    "caseAcceptanceRate",
    "rateLead",
    "caseAcceptance",
    "averageDuration",
    "appointmentsOverTreatment",
    "costAlignersData",
    "consumables",
    "bracesAverageDuration",
    "bracesAppointmentsOverTreatment",
    "costBracesPractice",
    "consumableTreatment",
  ];
  const dataToCheckSup0 = [
    "newAlignersTreatement",
    "newBraces",
    "teensYear",
    "whoAre",
    "averageSpend",
    "ppe",
    "stafCostHour",
    "appointementRefinement",
    "emergencyAppointments",
    "bracesInaddition",
    "percentageComingBack",
    "averageVistis",
    "labFee",
    "averageRelapse",
  ];
  const timeSpent = [
    "doctorTimeSpent",
    "dentalAssistant",
    "frontDesk",
    "treatmentCoordinator",
    "timeSpentCheckupAppointement",
    "checkupAppointement",
    "prepareAppointment",
  ];

  useEffect(() => {
    if (radio && checked) {
      setSelected(1);
    } else {
      setSelected(2);
    }
    if (Array.isArray(value) && checkIfAverageIsTrue(value)) {
      var obj = {};
      var l__changed = {};

      value.forEach((element) => {
        if (element.display || all) {
          obj[element.fieldName] = element.value;
          l__changed[element.fieldName] = false;
        }
      });
      setDefaultValue(obj);
      setChanged(l__changed);
      form.setFieldsValue(obj);
    } else {
      var obj = {};

      if (Array.isArray(value) && !checkIfAverageIsTrue(value)) {
        var x = value.filter((e) => e.fieldName == "average");
        obj[id] = x[0].value;

        setSuffixValue(x[0].suffix);
        setPrefixValue(x[0].prefix);
      } else {
        obj[id] = value;
      }
      form.setFieldsValue(obj);
      var l__changed = {};
      l__changed[id] = false;

      setChanged(l__changed);
      setDefaultValue(value);
    }
  }, [value, radio, separateTeensAdults, separateRole, showHourly, checked]);

  const onChange = () => {
    if (radio) {
      toUpdateRadio(id, selected, parent);
    } else {
      if (Array.isArray(value) && !checkIfAverageIsTrue(value)) {
        var json = { average: form.getFieldValue(id) };
        toUpdateForm(id, parent, json);
      } else {
        toUpdateForm(id, parent, form.getFieldsValue());
      }
    }
  };

  const shouldAdd = () => {
    return all || activeElement;
  };

  const onBlur = (ev, id) => {
    if (ev.target.value == "") {
      var json = form.getFieldsValue();
      json[id] = defaultValue;
      form.setFieldsValue(json);
      const c = { ...changed };

      c[id] = true;
      setChanged(c);
    }
  };

  const onBlurCustom = (ev, id) => {
    if (ev.target.value == "") {
      var json = form.getFieldsValue();
      json[id] = defaultValue[id];
      form.setFieldsValue(json);
      const c = { ...changed };
      c[id] = true;
      setChanged(c);
    }
  };

  const onChangeInput = (ev, id) => {
    if (!changed[id]) {
      var json = form.getFieldsValue();
      //json[id] = parseFloat(ev.nativeEvent.data);
      form.setFieldsValue(json);
    }
    const c = { ...changed };
    c[id] = true;
    setChanged(c);
  };

  const checkIfAverageIsTrue = (values) => {
    var element = values.filter((e) => e.fieldName == "average");
    if (element.length > 0) {
      return false;
    }
    return true;
  };

  const toCheckIfSumStaffDoctor = (rule, value, callback) => {
    if (staffTime < 1) {
      callback(getTranslatedValue("timeComplete"));
      return;
    }
    callback();
  };

  return (
    <>
      {showInput ? (
        <div className="roi--background-section" style={{ marginTop: "1vh" }}>
          {shouldAdd() && (
            <Form form={form} onChange={() => onChange()}>
              {Array.isArray(value) && checkIfAverageIsTrue(value) ? (
                <>
                  <Row>
                    <Col xl={24} md={24} style={{ display: "flex" }}>
                      <Tooltip
                        color="#EBEBEA"
                        fontFamily="Gotham"
                        fontSize="20px"
                        style={{
                          textColor: "#6a6e80",
                        }}
                        placement="rightTop"
                        title={
                          checkIfIdExists(idOfTooltip) && (
                            <FormattedMessage id={idOfTooltip} />
                          )
                        }
                      >
                        {checkIfIdExists(idOfTooltip) ? (
                          <img src="/images/icons/bull.svg" />
                        ) : (
                          <img src="/images/icons/bull-empty.svg" />
                        )}
                      </Tooltip>

                      <span
                        className="roi--label-section"
                        style={{ marginLeft: "2vh", marginTop: "10px" }}
                      >
                        <FormattedMessage id={id ? id : "test"} />
                      </span>
                    </Col>
                  </Row>
                  {!radio &&
                    value.map(
                      (e) =>
                        (e.display == true || all) && (
                          <Row style={{ marginTop: "1vh" }}>
                            <Col xl={1} md={1}></Col>
                            <Col xl={11} md={11}>
                              <span
                                className="roi--label-section"
                                style={{
                                  borderLeft: "1px solid #54596E",
                                  paddingLeft: "10px",
                                  display: "flex",
                                }}
                              >
                                <FormattedMessage id={e.fieldName} />
                              </span>
                            </Col>
                            <Col xl={8} md={11}>
                              <Form.Item
                                name={e.fieldName}
                                rules={[
                                  {
                                    validator: dataToCheckSup1.includes(id)
                                      ? dataSuperior
                                      : dataToCheckSup0.includes(id)
                                      ? dataSuperior0
                                      : timeSpent.includes(e.fieldName) &&
                                        toCheckIfSumStaffDoctor,
                                  },
                                ]}
                              >
                                <Input
                                  style={{ display: "flex" }}
                                  type="number"
                                  onBlur={(ev) => onBlurCustom(ev, e.fieldName)}
                                  suffix={e.suffix && e.suffix}
                                  prefix={e.prefix && e.prefix}
                                  onChange={(ev) =>
                                    onChangeInput(ev, e.fieldName)
                                  }
                                  className={
                                    !all && !changed[e.fieldName]
                                      ? "roi--input-default"
                                      : ""
                                  }
                                ></Input>
                              </Form.Item>
                            </Col>
                          </Row>
                        )
                    )}
                </>
              ) : (
                <Row>
                  <Col
                    xl={radio ? 24 : 12}
                    md={radio ? 24 : 12}
                    style={{ display: "flex" }}
                  >
                    <Tooltip
                      color="#EBEBEA"
                      fontFamily="Gotham"
                      fontSize="20px"
                      style={{ textColor: "#6a6e80" }}
                      placement="rightTop"
                      title={
                        checkIfIdExists(idOfTooltip) && (
                          <FormattedMessage id={idOfTooltip} />
                        )
                      }
                    >
                      {checkIfIdExists(idOfTooltip) ? (
                        <img src="/images/icons/bull.svg" />
                      ) : (
                        <img src="/images/icons/bull-empty.svg" />
                      )}
                    </Tooltip>

                    <span
                      className="roi--label-section"
                      style={{ marginLeft: "2vh", marginTop: "10px" }}
                    >
                      <FormattedMessage id={id ? id : "test"} />
                    </span>
                  </Col>
                  {!radio && (
                    <Col xl={8} md={11}>
                      <Form.Item
                        name={id ? id : "test"}
                        rules={[
                          {
                            validator: dataToCheckSup1.includes(id)
                              ? dataSuperior
                              : dataToCheckSup0.includes(id)
                              ? dataSuperior0
                              : timeSpent.includes(id) &&
                                toCheckIfSumStaffDoctor,
                          },
                        ]}
                      >
                        <Input
                          type="number"
                          suffix={suffixValue && suffixValue}
                          prefix={prefixValue && prefixValue}
                          onBlur={(ev) => onBlur(ev, id)}
                          onChange={(ev) => onChangeInput(ev, id)}
                          className={
                            !all && !changed[id] ? "roi--input-default" : ""
                          }
                        ></Input>
                      </Form.Item>
                    </Col>
                  )}
                </Row>
              )}

              {radio && (
                <Row style={{ marginTop: "1vh" }}>
                  <Col span={12} style={{ textAlign: "center" }}>
                    <Radio
                      className="roi--radio"
                      value={1}
                      checked={selected == 1}
                      onChange={() => {
                        setSelected(1);
                      }}
                    >
                      <FormattedMessage id="yes" />
                    </Radio>
                  </Col>
                  <Col span={12} style={{ textAlign: "center" }}>
                    <Radio
                      value={2}
                      className="roi--radio"
                      checked={selected == 2}
                      onChange={() => {
                        setSelected(2);
                      }}
                    >
                      <FormattedMessage id="no" />
                    </Radio>
                  </Col>
                </Row>
              )}
            </Form>
          )}
        </div>
      ) : (
        <div
          className={
            active
              ? "roi--background-section roi--show-hide"
              : "roi--background-section roi--show-hide roi--disabled-hide"
          }
        >
          <Row>
            <Col xl={10} md={12} style={{ display: "flex" }}>
              <Tooltip
                color="#EBEBEA"
                fontFamily="Gotham"
                fontSize="20px"
                style={{ textColor: "#6a6e80" }}
                placement="rightTop"
                title={
                  checkIfIdExists(idOfTooltip) && (
                    <FormattedMessage id={idOfTooltip} />
                  )
                }
              >
                {checkIfIdExists(idOfTooltip) ? (
                  <img src="/images/icons/bull.svg" />
                ) : (
                  <img src="/images/icons/bull-empty.svg" />
                )}
              </Tooltip>

              <span
                className="roi--label-section"
                style={{ marginLeft: "2vh", marginTop: "10px" }}
              >
                <FormattedMessage id={id ? id : "test"} />
              </span>
            </Col>
            <Col xl={12} md={10}>
              {!radio && (
                <Form.Item
                  rules={[
                    {
                      validator: dataToCheckSup1.includes(id)
                        ? dataSuperior
                        : dataToCheckSup0.includes(id)
                        ? dataSuperior0
                        : timeSpent.includes(id) && toCheckIfSumStaffDoctor,
                    },
                  ]}
                >
                  <Input
                    suffix={suffixValue && suffixValue}
                    prefix={prefixValue && prefixValue}
                    value={value && value}
                    disabled={true}
                  ></Input>
                </Form.Item>
              )}
            </Col>

            <Col xl={2} md={2} style={{ textAlign: "right" }}>
              {active ? (
                <img
                  style={{ cursor: "pointer", marginRight: "2px" }}
                  src="/images/icons/eyeActive.svg"
                  onClick={() => {
                    setActive(!active);
                    toHideUnhide(id, !active, parent);
                  }}
                />
              ) : (
                <img
                  style={{ cursor: "pointer", marginRight: "2px" }}
                  src="/images/icons/eyeInactif.svg"
                  onClick={() => {
                    setActive(!active);
                    toHideUnhide(id, !active, parent);
                  }}
                />
              )}
            </Col>
          </Row>
          {radio && (
            <Row style={{ margin: "1vh" }}>
              <Col md={10} style={{ textAlign: "center" }}>
                <Radio
                  value={1}
                  disabled={!active}
                  checked={selected == 1}
                  onChange={() => {
                    setSelected(1);
                  }}
                >
                  <FormattedMessage id="yes" />
                </Radio>
              </Col>
              <Col md={10} style={{ textAlign: "center" }}>
                <Radio
                  value={2}
                  disabled={!active}
                  checked={selected == 2}
                  onChange={() => {
                    setSelected(2);
                  }}
                >
                  <FormattedMessage id="no" />
                </Radio>
              </Col>
            </Row>
          )}
        </div>
      )}
    </>
  );
};
